import * as React from 'react';
import Video from './video';
import '../chiroto.css';

interface SessionProps {
  date?: string;
  songs?: string[];
  videos?: {song: string, title: string, video_id: string, date: string, section: number, orientation: string}[];//{title: string, path: string, orientation?: string}[];
  // link?: string;
  // title?: string;
  // technologies?: string[];
  // children?: React.ReactNode | React.ReactNode[];
}

class Session extends React.Component<SessionProps> {
  render() { 
    const {date, songs, videos} = this.props;
    const dateObj = date ? new Date(date) : undefined;
    const dateStr = dateObj ? dateObj.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : '';
    return (
      <div className="session" key={dateStr}>
        { (date)? <h2>{dateStr}</h2> : null }
        { (songs && songs.length > 0) ? <p>Songs:</p> : null }
        { (songs && songs.length > 0)? <ul>{songs.map((song, i) => <li key={i}>{song}</li>)}</ul> : null }
        <div className="grid-container">
          { (videos && videos.length > 0)
            ? videos.map((video, i) => {
                const orientation: "landscape" | "portrait" =
                  video.orientation === "landscape" ? "landscape" : "portrait";
                return (
                  <Video
                    title={`${video.song} Section ${video.section}, ${video.title}`}
                    path={`https://drive.google.com/file/d/${video.video_id}/preview`}
                    orientation={orientation}
                    key={i}
                  />
                );
              })
            : null }
        </div>
      </div>
    );
  }
}
 
export default Session;